export type IStorageClearByCondition = (value: any, key: string) => boolean;

/**
 * SGWTConnect data storage.
 *
 * Has the following features:
 *  - Automatic parsing of stringified data.
 *  - Prefixing of keys of stored data.
 */
export class SGWTConnectStorage {
  private baseStorageKey = 'SGWTConnectStorage';
  private get storageKey(): string {
    return this.hash ? `${this.baseStorageKey}.${this.hash}` : this.baseStorageKey;
  }

  constructor(private hash: string = '') {}

  public getItem(key: string): any {
    const item = localStorage.getItem(`${this.storageKey}.${key}`);
    return item === null ? null : JSON.parse(item);
  }

  public setItem(key: string, value: any): void {
    localStorage.setItem(`${this.storageKey}.${key}`, JSON.stringify(value));
  }

  public removeItem(key: string): void {
    localStorage.removeItem(`${this.storageKey}.${key}`);
  }

  public clearBy(satisfiesCondition: IStorageClearByCondition): void {
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key && key.indexOf(this.baseStorageKey) !== -1) {
        const value = localStorage.getItem(key);
        const parsedValue = value === null ? null : JSON.parse(value);
        if (satisfiesCondition(parsedValue, key)) {
          localStorage.removeItem(key);
        }
      }
    }
  }
}
